import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta06 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-06/utils-consultaSeguimentoPergunta06'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta06 } from './converter-HistoricoMchatPergunta06'

interface HistoricoMChatRfPergunta06Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta06 = (props: Readonly<HistoricoMChatRfPergunta06Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta06(aplicacoes)
  if (converted == null) return null

  const { header, perguntas, apontaPara, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta06(model)
  const isHeaderFalse = header.stPassou === false
  const exibirPergunta = isHeaderFalse ? '“Ele...”' : undefined

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='6'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={exibirPergunta}
      />
      {isHeaderFalse && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntas} />}
      {apontaPara && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[apontaPara]} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
